import {Box} from '@chakra-ui/react';
import type {FC, PropsWithChildren} from 'react';

import {useStyles} from './context';
import {parts} from './theme/anatomy';

export const NavMenu: FC<PropsWithChildren> = props => {
  const {children} = props;
  const {menu: style} = useStyles();
  return (
    <Box sx={style} {...parts.menu.attrs}>
      {children}
    </Box>
  );
};
